import { render } from "./GetApiData.vue?vue&type=template&id=a00f7d5a"
import script from "./GetApiData.vue?vue&type=script&lang=js"
export * from "./GetApiData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__